/**
 * Module actions
 */
export const MODULE_SET = 'MODULE_SET';
export const MODULE_RESET = 'MODULE_RESET';
export const MODULE_SELECTED = 'MODULE_SELECTED';

export function moduleSet(payload) {
    return { type: MODULE_SET, payload };
};
export function moduleReset() {
    return { type: MODULE_RESET };
};
export function moduleSelected(payload) {
    return { type: MODULE_SELECTED, payload };
};